<template>
  <div>
    <div class="oper_box">
      <el-button
        @click="
          addFirstOrder = true;
          cascadeType = 1;
        "
      >
        <img src="@/assets/button_imgs/tianjia.png" alt="" />
        添加一级项目
      </el-button>
      <el-button @click="addDeduction">
        <img src="@/assets/button_imgs/tianjia.png" alt="" />
        添加负分项
      </el-button>
    </div>
    <!-- 表格 -->
    <el-table
      :data="tableData"
      border
      stripe
      style="width: 100%"
      :summary-method="getSummaries"
      show-summary
      :header-cell-style="{
        'background-color': '#EEEEEE',
        color: '#333333',
        height: '60px',
      }"
    >
      <el-table-column label="一级项目" width="220">
        <template slot-scope="scope">
          <el-input
            class="one_input1"
            type="textarea"
            autosize
            :class="scope.row.stateNull == 1 ? 'redtes' : ''"
            @input="isNullState(scope.row, 'name')"
            v-model.trim="scope.row.name"
          ></el-input>
          <div class="oper_box">
            <el-button
              v-if="scope.row.buckleType == 1 || !scope.row.buckleType"
              type="primary"
              class="add_bz"
              @click="
                addFirstOrder = true;
                cascadeType = 2;
                indexs = scope.$index;
              "
            >
              <img src="@/assets/button_imgs/tianjia.png" alt="" />
              添加二级项目
            </el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="项目分" width="80" prop="projectScore">
        <template slot-scope="scope">
          <!-- {{ sumScore(scope.row)?sumScore(scope.row):'/' }} -->
          <div v-if="scope.row.buckleType == 1 || !scope.row.buckleType">
            {{ sumScore(scope.row) }}
          </div>
          <div v-else-if="scope.row.buckleType && scope.row.buckleType == 2">
            /
          </div>
        </template>
      </el-table-column>
      <el-table-column label="二级项目" width="180" class-name="table_3">
        <template slot-scope="scope">
          <div
            class="text_input1"
            v-for="(item, index) in scope.row.child"
            :key="index"
            :style="{ height: item.child.length * 120 + 'px' }"
          >
            <el-input
              v-model.trim="item.secondName"
              class="one_input1"
              :class="item.twoStateNull == 1 ? 'redtes' : ''"
              @input="isNullState(item, 'twoStateNull')"
              type="textarea"
              autosize
            ></el-input>
            <div class="oper_box">
              <el-button
                v-if="scope.row.buckleType == 1 || !scope.row.buckleType"
                type="primary"
                class="add_bz"
                @click="
                  cascadeType = 3;
                  addClick(item, scope.$index, index);
                "
              >
                <img src="@/assets/button_imgs/tianjia.png" alt="" />
                添加子项目
              </el-button>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="内容及评分标准" width="300" class-name="table_3">
        <template slot-scope="scope">
          <div
            v-for="(item, index) in scope.row.child"
            :key="index"
            class="text_div"
          >
            <div
              v-for="(zitem, zindex) in item.child"
              :key="zindex"
              class="text_input"
            >
              <el-input
                type="textarea"
                autosize
                placeholder="请输入内容"
                @input="isNullState(zitem, 'content')"
                :class="zitem.contentNull == 1 ? 'redtes' : ''"
                v-model.trim="zitem.content"
              ></el-input>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="分值" width="80" class-name="table_3">
        <template slot-scope="scope">
          <div
            class="text_div"
            :class="scope.row.buckleType == 1 ? 'lh75' : ''"
            v-for="(item, index) in scope.row.child"
            :key="index"
          >
            <div
              v-for="(zitem, zindex) in item.child"
              :key="zindex"
              class="text_input"
            >
              <el-input
                v-if="scope.row.buckleType == 1 || !scope.row.buckleType"
                v-model.trim="zitem.scoreValue"
                :class="zitem.scoreNull == 1 ? 'redtext' : ''"
                @input="isNullState(zitem, 'scoreNull')"
                style="width: 60px"
                maxlength="3"
              ></el-input>
              <!-- 负分项 -->
              <p
                v-else-if="scope.row.buckleType && scope.row.buckleType == 2"
                style="color: red; text-align: left"
              >
                扣分项不需要指定分数，根据实际规定扣分即可
              </p>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="得分" width="80" class-name="table_3">
        <template slot-scope="scope">
          <div
            class="text_div"
            style="line-height: 75px"
            v-for="(item, index) in scope.row.child"
            :key="index"
          >
            <div
              v-for="(zitem, zindex) in item.child"
              :key="zindex"
              class="text_input"
            ></div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="扣分细节" width="80" class-name="table_3">
        <template slot-scope="scope">
          <div
            class="text_div"
            style="line-height: 75px"
            v-for="(item, index) in scope.row.child"
            :key="index"
          >
            <div
              v-for="(zitem, zindex) in item.child"
              :key="zindex"
              class="text_input"
            ></div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="operation"
        label=""
        width="180"
        class-name="table_3"
      >
        <template slot-scope="scope">
          <div
            class="text_div"
            style="line-height: 75px"
            v-for="(item, index) in scope.row.child"
            :key="index"
          >
            <div
              style="line-height: 75px"
              v-for="(zitem, zindex) in item.child"
              :key="zindex"
              class="text_input"
            >
              <el-button
                type="text"
                :disabled="zindex == 0"
                @click="moveUp(zindex, item.child)"
                >上移</el-button
              >
              <el-button
                type="text"
                @click="moveDown(zindex, item.child)"
                :disabled="zindex == item.child.length - 1"
                >下移</el-button
              >
              <el-button
                type="text"
                @click="deleteClick(scope.row, scope.$index, index, zindex)"
                >删除</el-button
              >
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 添加一级二级项目弹窗 -->
    <div class="modify">
      <el-dialog
        :title="cascadeType == 1 ? '添加一级项目' : '添加二级项目'"
        :visible.sync="addFirstOrder"
        :close-on-click-modal="false"
      >
        <div class="mian">
          <p>{{ cascadeType == 1 ? "一" : "二" }}级项目名称：</p>
          <el-input
            v-model.trim="titleName"
            :placeholder="
              cascadeType == 1 ? '请输入一级项目名称' : '请输入二级项目名称'
            "
          ></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button
            @click="
              addFirstOrder = false;
              titleName = '';
            "
            >取 消</el-button
          >
          <el-button type="primary" @click="addClick">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [
        {
          buckleType: 1, // 是否扣分项 1 否 2 是
          name: "一级名称", // 一级项目名称
          projectScore: 0, // 项目分
          stateNull: "0", // 是否为空状态 0false 1true
          child: [
            {
              secondName: "二级名称", // 二级名称
              twoStateNull: "0", // 是否为空状态 0false 1true
              child: [
                {
                  content: "", // 内容及评分标准
                  scoreValue: 10, // 分值
                  contentNull: "0", // 是否为空状态 0false 1true
                  scoreNull: "0", // 是否为空状态 0false 1true
                },
              ],
            },
          ],
        },
      ],
      total: 1, // 合计
      addFirstOrder: false, // 添加一级弹窗
      titleName: "", // 一级名称
      cascadeType: 1,
      indexs: "", // 二层添加对应的索引
    };
  },
  methods: {
    // 添加
    addClick(row, indexs, index) {
      // console.log(this.cascadeType, "cascadeType");
      if (this.titleName == "" && this.cascadeType != 3) {
        this.$message({
          message: "警告，请添加项目名称",
          type: "warning",
        });
        return;
      }
      if (this.cascadeType == 1) {
        // 添加一级
        let obj = {
          buckleType: 1, // 是否扣分项 1 否 2 是
          name: this.titleName, // 一级项目名称
          projectScore: 0, // 项目分
          stateNull: "0", // 是否为空状态 0false 1true
          child: [
            {
              secondName: "", // 二级名称
              twoStateNull: "0", // 是否为空状态 0false 1true
              child: [
                {
                  content: "", // 内容及评分标准
                  scoreValue: "", // 分值
                  contentNull: "0", // 是否为空状态 0false 1true
                  scoreNull: "0", // 是否为空状态 0false 1true
                },
              ],
            },
          ],
        };
        this.tableData.push(obj);
        this.titleName = ""; // 置空
        this.addFirstOrder = false;
      } else if (this.cascadeType == 2) {
        // 添加二级
        let obj = {
          secondName: this.titleName, // 二级名称
          twoStateNull: "0", // 是否为空状态 0false 1true
          child: [
            {
              content: "", // 内容及评分标准
              scoreValue: "", // 分值
              contentNull: "0", // 是否为空状态 0false 1true
              scoreNull: "0", // 是否为空状态 0false 1true
            },
          ],
        };
        this.tableData[this.indexs].child.push(obj);
        this.titleName = ""; // 置空
        this.addFirstOrder = false;
      } else if (this.cascadeType == 3) {
        // 添加子项目
        let obj = {
          content: "", // 内容及评分标准
          scoreValue: "", // 分值
          contentNull: "0", // 是否为空状态 0false 1true
          scoreNull: "0", // 是否为空状态 0false 1true
        };
        this.tableData[indexs].child[index].child.push(obj);
        // console.log(this.tableData[indexs].child[index].child);
      }
      // console.log(this.tableData);
    },
    // 添加负分项
    addDeduction() {
      let obj = {
        buckleType: 2, // 是否扣分项 1 否 2 是
        name: "扣分", // 一级项目名称
        projectScore: -1, // 项目分
        stateNull: "0", // 是否为空状态 0false 1true
        child: [
          {
            secondName: "扣分细节", // 二级名称
            twoStateNull: "0", // 是否为空状态 0false 1true
            child: [
              {
                content: "", // 内容及评分标准
                scoreValue: -1, // 分值
                contentNull: "0", // 是否为空状态 0false 1true
                scoreNull: "0", // 是否为空状态 0false 1true
              },
            ],
          },
        ],
      };
      this.tableData.push(obj);
    },
    // 上移
    moveUp(index, newarr) {
      let arr = newarr;
      arr.splice(index - 1, 1, ...arr.splice(index, 1, arr[index - 1]));
    },
    // 下移
    moveDown(index, newarr) {
      let arr = newarr;
      arr.splice(index, 1, ...arr.splice(index + 1, 1, arr[index]));
    },
    // 删除
    deleteClick(row, index, indexs, zindex) {
      // console.log(this.tableData[index].child.length);
      if (
        this.tableData[index].child.length == 1 &&
        this.tableData[index].child[indexs].child.length == 1
      ) {
        // 删除整个一级
        this.tableData.splice(index, 1);
      } else if (this.tableData[index].child[indexs].child.length == 1) {
        // 删除整个二级
        this.tableData[index].child.splice(zindex, 1);
      } else {
        // 删除单个
        this.tableData[index].child[indexs].child.splice(zindex, 1);
      }
      return;
      this.tableData.splice(index, 1);
    },
    // 名称不为空清除红框
    isNullState(row, type) {
      if (type == "name") {
        if (row.name == "") {
          return;
        } else if (row.name !== "" && row.stateNull) {
          row.stateNull = "0";
        }
      } else if (type == "twoStateNull") {
        if (row.secondName == "") {
          return;
        } else if (row.name !== "" && row.twoStateNull) {
          row.twoStateNull = "0";
        }
      } else if (type == "content") {
        if (row.content == "") {
          return;
        } else if (row.content !== "" && row.contentNull) {
          row.contentNull = "0";
        }
      } else {
        if (row.scoreValue == "") {
          return;
        } else if (row.scoreValue !== "" && row.scoreNull) {
          row.scoreNull = "0";
        }
      }
    },
    //合计
    getSummaries(param) {
      let { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        data = data.filter((item) => {
          if (item.buckleType == 1 || !item.buckleType) {
            return item; // 扣分项不参与合计计算
          }
        });
        const values = data.map((item) => Number(item[column.property]));
        if (column.property === "projectScore") {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index];
        }
      });
      this.total = sums[1];
      return sums;
    },
    //
  },
  computed: {
    // 计算二级小节的合计
    sumScore() {
      return function (row) {
        if (row.buckleType == 1 || !row.buckleType) {
          let newarr = row.child.map((item) => {
            return item.child.map((zitem) => {
             if(zitem.scoreValue){
               return zitem.scoreValue
             }
            });
          });
          let sum = 0;
          newarr.flat().map(function (item) {
            sum += Number(item);
            return sum;
          });
          row.projectScore = sum;
          return row.projectScore;
        }
      };
    },
  },
  created() {
    if (this.$route.query.type == 1) {
      // 编辑回显
      let row = this.$storage.sessionGet("rowObj", true);
      this.tableData = JSON.parse(row.ContentTxt).map((item) => {
        if (item.buckleType && item.buckleType == 2) {
          item.projectScore = -1;
        }
        return item;
      });
      // 有上传表格无scoreValue字段
      this.tableData.forEach((item) => {
        if (item.child) {
          item.child.forEach((zitem) => {
            if(zitem.child){
              zitem.child.forEach(sitem=>{
                  if(!sitem.scoreValue){
                    sitem.scoreValue = 0 // 给个默认值
                  }
              })
            }
          });
        }
      });
    console.log(this.tableData);
    }
  },
};
</script>

<style lang="scss" scoped>
.one_input1 {
  ::v-deep .el-textarea__inner {
    resize: none;
    width: 160px;
    height: 40px !important;
  }
}
.oper_box {
  display: flex;
  margin: 14px 0px 20px 0px;
  min-width: 88px;
  height: 40px;
  opacity: 1;
  border-radius: 4px;
  ::v-deep .el-button {
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 112px;
    height: 40px;
    background: #ebecf1;
    border-radius: 3px;
    letter-spacing: 1px;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: #000000;
    &:nth-child(1) {
      min-width: 140px;
    }
    span {
      display: flex;
      align-items: center;
    }
    span > img {
      width: 14px;
      height: 14px;
      margin-right: 5px;
    }
  }
}
::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f9f9f9 !important;
}
::v-deep .el-table__cell {
  text-align: center;
}
.cell {
  text-align: center;
}
.red {
  border: 1px solid red;
  border-radius: 4px;
  &:focus {
    border-color: red !important;
  }
}
.add_bz {
  //   margin-top: 24px;
  background: #409eff !important;
  color: #fff !important;
}
.text_div {
  margin-bottom: 8px;
  border-bottom: 1px solid #ebeef5;
  //   padding: 0px 10px 6px 10px;
  &:last-child {
    border: none !important;
  }
}
.text_input {
  margin-bottom: 8px;
  border-bottom: 1px solid #ebeef5;
  //   padding: 0px 10px 6px 10px;
  //   height: 85px;
  height: 111px;
  &:last-child {
    border: none !important;
    height: 100%;
  }
  ::v-deep .el-textarea {
    display: flex;
    justify-content: center;
    align-content: center;
  }
  ::v-deep .el-textarea__inner {
    // max-height: 60px !important;
    resize: none;
    width: 280px;
    height: 110px !important;
    // margin: 6px 10px;
  }
}
.text_input1 {
  margin-bottom: 4px;
  border-bottom: 1px solid #ebeef5;
  padding: 0px 10px 6px 10px;
  //   height: 180px;
  //   line-height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  &:last-child {
    border: none !important;
  }
}
::v-deep .table_3 {
  .cell {
    padding: 0 !important;
  }
}
.modify {
  .title_box {
    // height: 54px;
    padding-bottom: 9px;
    margin-bottom: 20px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 19px;
    color: #333333;
    border-bottom: 1px solid #abd7ff;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
  ::v-deep .dialog-footer {
    margin-bottom: 30px;
  }
  ::v-deep.el-dialog__footer {
    // justify-content: left !important;
  }
  span > button:nth-child(3) {
    margin-left: 50px;
  }
  ::v-deep .el-dialog__footer span > button:nth-child(2) {
    margin-left: 0;
  }
  .mian {
    display: flex;
    align-items: center;
    p {
      width: 140px;
    }
    ::v-deep .el-input__inner {
      width: 280px;
    }
  }
  .el-dialog__footer span > button {
    margin-top: 10px;
  }
  ::v-deep .el-dialog {
    width: 500px;
    border-radius: 5px 5px 0px 0px;
    .input_layout {
      display: flex;
      > .el-form-item {
        flex: 1;
        display: flex;
        align-content: center;
        ::v-deep .el-input {
          width: 420px;
        }
      }
    }
  }
}
::v-deep .el-dialog__headerbtn .el-dialog__close {
  font-size: 24px;
  color: #fff;
}
::v-deep .el-dialog__header {
  height: 55px;
  background: #0084ea;
  opacity: 1;
  border-radius: 5px 5px 0px 0px;
  font-size: 16px;
  letter-spacing: 2px;
  font-family: PingFang SC;
  box-sizing: border-box;
  text-align: center;
  .el-dialog__title {
    color: #fff;
  }
}
::v-deep .el-dialog__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
::v-deep .el-dialog__footer {
  padding: 0;
  text-align: center;
  display: flex;
  justify-content: center;
  align-content: center;
  button {
    width: 80px;
    height: 40px;
    border-radius: 2px;
    color: #fff;
    font-size: 14px;
    &:nth-child(1) {
      background: #c4c4c4;
      margin-right: 10px;
    }
    &:nth-child(2) {
      background: #0084ea;
    }
  }
}
.modify {
  .title_box {
    // height: 54px;
    padding-bottom: 9px;
    margin-bottom: 20px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 19px;
    color: #333333;
    border-bottom: 1px solid #abd7ff;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
  ::v-deep .dialog-footer {
    margin-bottom: 30px;
  }
  ::v-deep.el-dialog__footer {
    justify-content: left !important;
  }
  span > button:nth-child(3) {
    margin-left: 50px;
  }
  ::v-deep .el-dialog__footer span > button:nth-child(2) {
    margin-left: 0;
  }
  .mian {
    display: flex;
    align-items: center;
    p {
      width: 140px;
    }
    ::v-deep .el-input__inner {
      width: 280px;
    }
  }
  .el-dialog__footer span > button {
    margin-top: 10px;
  }
  ::v-deep .el-dialog {
    width: 500px;
    border-radius: 5px 5px 0px 0px;
    .input_layout {
      display: flex;
      > .el-form-item {
        flex: 1;
        display: flex;
        align-content: center;
        ::v-deep .el-input {
          width: 420px;
        }
      }
    }
  }
}
::v-deep .el-dialog__headerbtn .el-dialog__close {
  font-size: 24px;
  color: #fff;
}
::v-deep .el-dialog__header {
  height: 55px;
  background: #0084ea;
  opacity: 1;
  border-radius: 5px 5px 0px 0px;
  font-size: 16px;
  letter-spacing: 2px;
  font-family: PingFang SC;
  box-sizing: border-box;
  text-align: center;
  .el-dialog__title {
    color: #fff;
  }
}
::v-deep .el-dialog__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
::v-deep .el-dialog__footer {
  padding: 0;
  text-align: center;
  display: flex;
  justify-content: center;
  align-content: center;
  button {
    width: 80px;
    height: 40px;
    border-radius: 2px;
    color: #fff;
    font-size: 14px;
    &:nth-child(1) {
      background: #c4c4c4;
      margin-right: 10px;
    }
    &:nth-child(2) {
      background: #0084ea;
    }
  }
}
.redtes {
  ::v-deep .el-textarea__inner {
    border-color: red !important;
  }
}
.redtext {
  ::v-deep .el-input__inner {
    border-color: red !important;
  }
}
.lh75 {
  line-height: 75px;
}
</style>